import React from "react";
import styled from "styled-components";
import TopNavbarForPolicy from "../components/Nav/TopNavbarForPolicy";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"

export default function FAQ() {
  return (
    <Wrapper>
      <TopNavbarForPolicy />
      <Container>
        <Title>Frequently Asked Questions</Title>
        <Content>
          <Section>
            <SubTitle>Why Should I Care About Alt Text?</SubTitle>
            <p>
              The alt text (alt tag), which is an attribute that describes the nature or content of an image, has an important role to play in SEO optimization. Google uses it to understand what the image contains. The alt text helps search engines recognize what is on a given page and ranks it accordingly.
            </p>
          </Section>
          <Section>
            <SubTitle>How Can I Reoptimize My Alt Texts?</SubTitle>
            <p>
              You can change your alt text templates and re-optimize all your images anytime.
            </p>
          </Section>
          <Section>
            <SubTitle>If I'm Not Happy With The Results, Can I Get My Original Alt Texts Back?</SubTitle>
            <p>
              The Alt Text app doesn't back up your product images. We highly recommend you back up your store before optimizing all your images. The backup apps let you restore any unwanted changes to your store.
            </p>
          </Section>
          <Section>
            <SubTitle>What Will Speed Extension Do?</SubTitle>
            <p>
              It's simple! The app automatically improves your store's loading speed by preloading links within the user's viewport.
            </p>
          </Section>
          <Section>
            <SubTitle>How Does This Help My Store?</SubTitle>
            <p>
              Amazon and others found that cutting 100 milliseconds of latency improves sales by 1%. This app will help improve your conversions.
            </p>
          </Section>
          <Section>
            <SubTitle>How Do I Uninstall The Speed Extension?</SubTitle>
            <p>
              Simply turn the switch to OFF in the app embed section of the theme editor. No Code Is Added To Your Theme.
            </p>
          </Section>
          <Section>
            <SubTitle>Why Hasn't My Speed Score Changed?</SubTitle>
            <p>
              This app will not increase or decrease any pageload speed metrics such as Pingdom or Gmetrix. The app preloads links, which only works from the second page view. These apps (Pingdom or Gmetrix) DO NOT account for second page load times in their results.
            </p>
          </Section>
          <Section>
            <SubTitle>Does the app update image alt text for all products?</SubTitle>
            <p>
              No, the app only updates image alt text for active products. Draft and archived products are not affected, as only active products impact SEO.
            </p>
          </Section>
        </Content>
        <Contact />
      </Container>
      <Footer />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 50px 20px;
  background-color: #f7f7f7;
  font-family: 'Khula', sans-serif;
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
`;

const Content = styled.div`
  margin-top: 20px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SubTitle = styled.h2`
  font-size: 1.5rem;
  color: #555;
  margin-bottom: 10px;
`;
